import Vue from 'vue'
import AuthClient from './clients/AuthClient'
import Table from './clients/Table'
import CalendarClient from './clients/Calendar'
import ProfileClient from './clients/Profile'

const api = {
  Auth: AuthClient,
  Crud: Table,
  Calendar: CalendarClient,
  Profile: ProfileClient
}

export const bootstrap = async () => {
  Vue.use({
    install (Vue) {
      Vue.prototype.$api = api
    }
  })
}

export default api
